import { gql } from "@apollo/client";
import VendorFields from "~/lib/queries/fragments/VendorFields";

export default gql`
  query Vendor($slug: String!, $language: String) {
    company(slug: $slug, language: $language) {
      _id
      ...VendorFields
    }
  }

  ${VendorFields}
`;
